import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { History } from '@material-ui/icons';
import { useState } from 'react';
import { ChangeLogTable } from './change-log-table';

export function ChangeLogAction({ changeLog, studentName }) {
  const [open, setOpen] = useState(false);

  if (!changeLog?.length) {
    return null;
  }

  return (
    <>
      <Button onClick={() => setOpen(true)} color="default" startIcon={<History />}>
        Edições
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>Edições{studentName ? ` - ${studentName}` : ''}</DialogTitle>
        <DialogContent>
          <ChangeLogTable changeLog={changeLog} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="default">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
